<template>
  <img
    :src="_url"
    :alt="alt"
    :height="height"
    :width="width"
    :class="classes"
    :style="styles"
    :title="title"
    @click="onClick"
    @focus="onFocus"
    @blur="onBlur"
    @keyup="onKeyPress"
    @keypress.enter.prevent="onKeyPressEnter"
  />
</template>

<script>
export default {
  /**
   tag
   name: ks-image
   description: ks-image
   **/
  name: "ks-image",
  props: {
    /**
      attribute
      name: url
      description: url
     **/
    url: {
      type: String,
      required: false
    },
    /**
      attribute
      name: src
      description: src
    **/
    src: {
      type: String,
      required: false
    },
    /**
      attribute
      name: alt
      description: alt
    **/
    alt: {
      type: String,
      default: ''
    },
    /**
      attribute
      name: title
      description: title
    **/
    title: {
      type: String,
      default: null
    },
    /**
     attribute
     name: private
     description: add app token
     **/
    private: {
      type: Boolean,
      default: false
    },
    /**
     attribute
     name: width
     description: width
     **/
    width: {
      type: String,
      default: '500'
    },
    /**
     attribute
     name: height
     description: height
     **/
    height: {
      type: String,
      default: '500'
    },
    /**
     attribute
     name: classes
     description: class string
     **/
    classes: {
      type: String,
      default: null
    },
    /**
     attribute
     name: styles
     description: style string
     **/
    styles: {
      type: String,
      default: null
    }
  },
  computed: {
    _url() {
      return `${this.url ? this.url : this.src}${this.private ? `?token=${app.auth.urlToken}` : ''}`;
    }
  },
  methods: {
    onClick(evt) {
      this.$emit('onClick', {'ref': this, 'event': evt});
    },
    onFocus(evt) {
      this.$emit('onFocus', {'ref': this, 'event': evt});
    },
    onBlur(evt) {
      this.$emit('onBlur', {'ref': this, 'event': evt});
    },
    onKeyPress(evt) {
      this.$emit('onKeyPress', {'ref': this, 'event': evt});
    },
    onKeyPressEnter(evt) {
      this.$emit('onKeyPressEnter', {'ref': this, 'event': evt});
    },
  }
};
</script>
